import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EColors2 } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    isWide: boolean;
    icon: IconProp;
    onClick?: () => void;
    children?: React.ReactNode;
}

export const ProgramListItemActionButton = (props: Props): JSX.Element => {
    return (
        <S_ProgramListItemActionButton
            $isWide={props.isWide}
            className={props.className}
            onClick={props.onClick}
        >
            <S_ButtonIcon $isWide={props.isWide} icon={props.icon} />
            {props.children}
        </S_ProgramListItemActionButton>
    );
};

const S_ButtonIcon = styled(FontAwesomeIcon)<{ $isWide: boolean }>`
    font-size: 18px;
    color: #3a3a3a;

    ${(props) => {
        if (props.$isWide) {
            return css`
                font-size: 20px;
            `;
        }
    }}
`;

const S_ProgramListItemActionButton = styled.div<{ $isWide: boolean }>`
    width: 40px;
    height: 40px;
    border-radius: 15px;
    background: #fff;
    box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.01);
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
        color: white;
        cursor: pointer;
        background-color: ${EColors2.DARK};
        transform: scale(1.05);
        ${S_ButtonIcon} {
            color: white;
        }
    }

    ${(props) => {
        if (props.$isWide) {
            return css`
                width: 50px;
                height: 50px;
                border-radius: 15px;
            `;
        }
    }}
`;
